
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Roofing from "../pages/roofing/page";
import HVAC from "../pages/hvac/page";
import Countertops from "../pages/countertops/page";
import Handyman from "../pages/handyman/page";
import Plumbing from "../pages/plumbing/page";
import CustomHomes from "../pages/custom-homes/page";
import Tile from "../pages/tile/page";
import WindowsDoor from "../pages/windows-doors/page";
import Solar from "../pages/solar/page";
import Electrical from "../pages/electrical/page";
import Painting from "../pages/painting/page";
import Flooring from "../pages/flooring/page";
import Pool from "../pages/pool/page";
import Drywall from "../pages/drywall/page";
import GarageDoor from "../pages/garage-door/page";
import Masonry from "../pages/masonry/page";
import Fence from "../pages/fence/page";
import Fireproofing from "../pages/fireproofing/page";
import ResidentialRemodelingPage from "../pages/residential-remodeling/page";
import CustomHomeBuildersPage from "../pages/custom-home-builders/page";
import CommercialContractorsPage from "../pages/commercial-contractors/page";
import SitemapPage from "../pages/sitemap/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/roofing-contractors-el-paso",
    element: <Roofing />,
  },
  {
    path: "/hvac-contractors-el-paso",
    element: <HVAC />,
  },
  {
    path: "/granite-quartz-countertops-el-paso",
    element: <Countertops />,
  },
  {
    path: "/handyman-services-el-paso",
    element: <Handyman />,
  },
  {
    path: "/plumbing-contractors-el-paso",
    element: <Plumbing />,
  },
  {
    path: '/residential-remodeling-contractors-el-paso',
    element: <ResidentialRemodelingPage />,
  },
  {
    path: '/custom-home-builders-el-paso',
    element: <CustomHomeBuildersPage />,
  },
  {
    path: '/commercial-contractors-el-paso',
    element: <CommercialContractorsPage />,
  },
  {
    path: "/tile-installers-el-paso",
    element: <Tile />,
  },
  {
    path: "/window-door-replacement-el-paso",
    element: <WindowsDoor />,
  },
  {
    path: "/solar-contractors-el-paso",
    element: <Solar />,
  },
  {
    path: "/electrical-contractors-el-paso",
    element: <Electrical />,
  },
  {
    path: "/painting-contractors-el-paso",
    element: <Painting />,
  },
  {
    path: "/flooring-contractors-el-paso",
    element: <Flooring />,
  },
  {
    path: "/swimming-pool-contractors-el-paso",
    element: <Pool />,
  },
  {
    path: "/drywall-contractors-el-paso",
    element: <Drywall />,
  },
  {
    path: "/garage-door-contractors-el-paso",
    element: <GarageDoor />,
  },
  {
    path: "/masonry-contractors-el-paso",
    element: <Masonry />,
  },
  {
    path: "/fence-contractors-el-paso",
    element: <Fence />,
  },
  {
    path: "/fireproofing-companies-el-paso",
    element: <Fireproofing />,
  },
  {
    path: "/sitemap",
    element: <SitemapPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
